import { isClickedOutside } from '@theme/utilities';

class DropdownGroupComponent extends HTMLElement {
  constructor() {
    super();

    this.dropdowns = [];
  }

  connectedCallback() {
    this.dropdowns = this.querySelectorAll('dropdown-component');

    document.addEventListener('click', this.#handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#handleDocumentClick);
  }

  #handleDocumentClick = (event) => {
    const clickedInsideDropdown = event.target.closest('dropdown-component');
    if (!clickedInsideDropdown) {
      this.closeAllDropdowns();
    }
  };

  closeAllDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      dropdown.close();
    });
  }
}

if (!customElements.get('dropdown-group-component')) {
  customElements.define('dropdown-group-component', DropdownGroupComponent);
}

class DropdownComponent extends HTMLElement {
  constructor() {
    super();

    this.toggle = null;
    this.content = null;
    this.isOpen = false;
  }

  connectedCallback() {
    this.toggle = this.querySelector('[data-ref="dropdown-toggle"]');
    this.content = this.querySelector('[data-ref="dropdown-content"]');

    this.toggle?.addEventListener('click', this.#handleToggle);
    if (this.classList.contains('header__menu-item')) {
      if (this.content && this.toggle) {
        this.content.id ||= `header-dropdown-${crypto.randomUUID()}`;
        this.toggle.setAttribute('aria-controls', this.content.id);
        this.toggle.setAttribute('aria-expanded', 'false');
        this.content.inert = true;
      }
      this.addEventListener('keydown', this.#handleNavigationKey);
      this.addEventListener('focusout', this.#handleFocusOut);
    }
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.#handleToggle);
    document.removeEventListener('click', this.#handleClickOutside);
    this.removeEventListener('keydown', this.#handleNavigationKey);
    this.removeEventListener('focusout', this.#handleFocusOut);
  }

  #handleNavigationKey = (event) => {
    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault();
      this.close();
      this.toggle?.focus();
    } else if (event.key === 'ArrowDown' && event.target === this.toggle) {
      event.preventDefault();
      this.closest('dropdown-group-component')?.closeAllDropdowns();
      this.open();
      this.content?.querySelector('a[href], button')?.focus();
    }
  };

  #handleFocusOut = (event) => {
    if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
  };

  #handleToggle = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (this.isOpen) {
      this.close();
    } else {
      this.closest('dropdown-group-component')?.closeAllDropdowns();
      this.open();
    }
  };

  #handleClickOutside = (event) => {
    if (isClickedOutside(event, this)) {
      this.close();
    }
  };

  open() {
    this.setAttribute('data-open', 'true');
    if (this.classList.contains('header__menu-item')) {
      this.toggle?.setAttribute('aria-expanded', 'true');
      if (this.content) {
        this.content.inert = false;
        this.style.setProperty('--bep-menu-top', `${Math.max(0, this.content.getBoundingClientRect().top)}px`);
      }
    }
    document.addEventListener('click', this.#handleClickOutside);
    this.isOpen = true;
  }

  close() {
    this.setAttribute('data-open', 'false');
    if (this.classList.contains('header__menu-item')) {
      this.toggle?.setAttribute('aria-expanded', 'false');
      if (this.content) this.content.inert = true;
    }
    document.removeEventListener('click', this.#handleClickOutside);
    this.isOpen = false;
  }
}

if (!customElements.get('dropdown-component')) {
  customElements.define('dropdown-component', DropdownComponent);
}
